<template>
	<v-layout class="multiimagebox">
		<!-- <input ref="file" type="file" style="display:none;" :multiple="multi" @change="handleFileUpload()" /> -->
		<v-flex xs12 sm6 offset-sm3>
			<v-card style="position: relative;min-height:200px;">
				<v-btn v-if="add" absolute fab top right round @click="clickInput()">
					<v-icon>add_a_photo</v-icon>
				</v-btn>
				<v-btn v-if="add" absolute fab bottom right round color="green" :disabled="!isValid" @click="saveInput()">
					<v-icon>cloud_upload</v-icon>
				</v-btn>
				<v-container grid-list-sm fluid>
					<draggable v-model="elements" class="layout row wrap" :draggable="add ? 'do-not-drag' : '.drag-item'">
						<v-flex v-for="(element, i) in elements" :key="i" xs6 sm3 class="drag-item">
							<v-card v-if="element && i < max" flat tile>
								<v-img v-if="element.src" :src="element.src" :lazy-src="element.src" aspect-ratio="1" class="grey lighten-2">
									<v-layout fill-height :class="element.isNew && element.loaded !== 100 ? 'repeating-gradient' : ''" style="position:relative;">
										<v-btn color="red" absolute right dark small fab style="top: calc(100% - 50px);" @click.stop="showDialog(element.id)">
											<v-icon>remove</v-icon>
										</v-btn>
										<span v-if="element.title" class="headline white--text pt-2 pl-3 pb-2 pr-3" top left style="word-break: break-all;" v-text="element.title"></span>
									</v-layout>
									<template v-slot:placeholder>
										<v-layout fill-height align-center justify-center ma-0>
											<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
										</v-layout>
									</template>
									<v-progress-circular v-if="element.loaded > 0 && element.loaded < 100" style="position: absolute;top: calc(50% - 50px);left: calc(50% - 50px);" :rotate="180" :size="100" :width="15" :value="element.loaded" :color="getColor(element.loaded)">
										{{ element.loaded }}
									</v-progress-circular>
								</v-img>
							</v-card>
						</v-flex>
						<v-flex xs12 sm3 class="drag-item">
							<v-card v-if="elements.length > max" flat tile>
								<v-btn color="red" dark fab style="top: calc(100% - 50px);" @click="max += 10">
									<v-icon>filter_9_plus</v-icon>
								</v-btn>
							</v-card>
						</v-flex>
					</draggable>
				</v-container>
			</v-card>
		</v-flex>
		<v-dialog v-model="dialog" max-width="290">
			<v-card>
				<v-card-title class="headline">Do you really want to delete this?</v-card-title>
				<v-card-text>
					If you agree it will be gone - FOREVER GONE!!!
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1" flat="flat" @click="dialog = false">Disagree</v-btn>
					<v-btn color="green darken-1" flat="flat" @click="agreeDialog()">Agree</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import draggable from 'vuedraggable'
export default {
	name: 'MultiImageBox',
	components: {
		draggable
	},
	props: {
		isOverview: Boolean,
		add: {
			type: Boolean,
			required: true
		},
		isValid: {
			type: Boolean,
			required: false,
			default: false
		},
		remove: {
			type: Function,
			required: true
		},
		clickInput: {
			type: Function,
			required: false,
			default: () => {
				return false
			}
		},
		saveInput: {
			type: Function,
			required: false,
			default: () => {
				return false
			}
		}
	},
	data: () => ({
		dialog: false,
		max: 10
	}),
	computed: {
		sources() {
			return this.$store.state.sources
		},
		elements: {
			get() {
				if (this.isOverview) {
					return this.sources ? this.$store.state.cards.concat(this.sources) : this.$store.state.cards
				} else {
					return this.sources ? this.$store.state.images.concat(this.sources).slice(0, this.max) : this.$store.state.images
				}
			},
			set(value) {
				var newOrder = value.map((element, idx) => {
					element.order = idx + 1
					return element
				})
				if (this.isOverview) {
					this.$store.commit('setCards', newOrder)
				} else {
					this.$store.commit('setImages', newOrder)
				}
			}
		}
	},
	methods: {
		getColor(val) {
			var color = 'green'
			color = val < 40 ? 'red' : color
			color = val < 80 ? 'yellow' : color
			return color
		},
		showDialog(id) {
			this.currentItem = id
			this.dialog = true
		},
		agreeDialog() {
			this.dialog = false
			this.remove(this.currentItem)
		}
	}
}
</script>
<style>
.repeating-gradient {
	background-image: repeating-linear-gradient(-45deg, rgba(255, 0, 0, 0.25), rgba(255, 0, 0, 0.25) 5px, rgba(0, 0, 255, 0.25) 5px, rgba(0, 0, 255, 0.25) 10px);
}
</style>
